<template lang="pug">
.training(
  :class="[isCollapsed ? 'training_collapsed' : '', isToggleable ? 'training_toggleable' : '']",
  ref="container"
)
  a.training__header(
    href="#",
    @click.prevent="isToggleable ? (isCollapsed = !isCollapsed) : null"
  )
    .training__header-row.training__header-row_first(ref="header")
      .training__header-col
        .training__icon(:class="'bg-' + types[data.type].icon")
          icon.icon(:icon-name="types[data.type].icon")
      .training__header-col.training__info
        b.training__info-title.text-lg {{ types[data.type].name }}
        .training__info-text.text-sm(v-html="date")
      .training__header-col.training__collapse(v-if="isToggleable")
        button.link.link_light(tabindex="-1")
          icon(
            icon-name="up",
            class-name="icon",
            w="24",
            h="24",
            v-show="!isCollapsed"
          )
          icon(
            icon-name="down",
            class-name="icon",
            w="24",
            h="24",
            v-show="isCollapsed"
          )
  .training__body(ref="body")
    .training__body-wrap
      .training-interval(v-for="interval in data.intervals")
        .training-interval__time(
          v-if="interval.time && interval.time.length > 0"
        )
          .t1 {{ $moment(interval.time[0]).format('HH:mm') }}
          .t2 {{ $moment(interval.time[1]).format('HH:mm') }}
        .training-interval__source(v-for="source in interval.sources")
          .training-tracker
            .training-tracker__header
              .training-tracker__name
                .text-with-icon.text-sm.d-flex(v-if="source.id === 'strava'")
                  .icon.square-icon.square-icon_shadow.square-icon_sm(
                    :style="'background-image: url(' + sourceImg('logos/strava-app.png') + ')'"
                  )
                  b Strava
              .training-tracker__details(v-if="source.id === 'strava'")
                a.link.link_light.text-xs(
                  :href="`https://www.strava.com/activities/${interval.activityId}`",
                  target="_blank",
                  rel="noopener noreferrer"
                ) См. на Strava
            .training-tracker__body
              .metrics
                .metrics__item(v-for="metric in source.metrics")
                  MetricsItem(
                    :name="metric.name",
                    :value="metric.value",
                    :units="metric.units"
                  )
</template>

<script>
import { StickyEl, slideToggle } from '@/assets/js/animation'
import MetricsItem from '@/components/MetricsItem'

export default {
  name: 'Training',
  components: {
    MetricsItem
  },
  props: {
    data: Object,
    isToday: Boolean,
    isToggleable: Boolean
  },
  data () {
    return {
      isCollapsed: true,
      isPinned: false,
      pinned: [],
      types: {
        walking: {
          name: 'Ходьба',
          icon: 'walking'
        },
        gymnastics: {
          name: 'Гимнастика',
          icon: 'gymnastics'
        },
        running: {
          name: 'Бег',
          icon: 'running'
        },
        cycling: {
          name: 'Велозаезд',
          icon: 'cycling'
        },
        swimming: {
          name: 'Плавание',
          icon: 'swimming'
        },
        skiing: {
          name: 'Лыжи',
          icon: 'skiing'
        }
      }
    }
  },
  computed: {
    date () {
      const date = this.$moment(this.data.date)
      const isSameYear = date.isSame(this.$moment(), 'year')

      const year = isSameYear ? '' : 'YYYY '
      const month = date.format('MMM').slice(0, 3)
      const format = `D [${month}] ${year}[в] HH:mm`

      return date.calendar(null, {
        sameDay: '[Сегодня в ] HH:mm',
        nextDay: '[Завтра в ] HH:mm',
        lastDay: '[Вчера в ] HH:mm',
        nextWeek: format,
        lastWeek: format,
        sameElse: format
      })
    }
  },
  methods: {
    sourceImg (id) {
      return id ? require(`@/assets/img/${id}`) : null
    },
    pinElements () {
      if (this.isPinned) {
        return
      }
      const header = document.querySelector('.header')
      const headerOffset = header ? header.offsetHeight : 0
      this.isPinned = true

      const pinnedHeader = new StickyEl(
        this.$refs.header,
        this.$refs.container,
        {
          offset: -headerOffset + 4,
          durationOffset: -8
        }
      )
      this.pinned.push(pinnedHeader)

      const t1 = this.$el.querySelectorAll('.t1')
      t1.forEach((el) => {
        const pinnedEl = new StickyEl(el, el.parentElement, {
          offset: -headerOffset - 72,
          durationOffset: -22
        })
        this.pinned.push(pinnedEl)
      })

      const t2 = this.$el.querySelectorAll('.t2')
      t2.forEach((el) => {
        const pinnedEl = new StickyEl(el, el.parentElement, {
          triggerHook: 'onEnter',
          offset: 44,
          durationOffset: -22
        })
        this.pinned.push(pinnedEl)
      })
    }
  },
  watch: {
    isCollapsed (val) {
      if (!this.isToggleable) {
        return
      }
      slideToggle(this.$refs.body, !val)
      if (!val) {
        setTimeout(() => {
          if (!this.isPinned) {
            this.pinElements()
          } else {
            this.pinned.forEach((el) => {
              el.refresh()
            })
          }
        }, 400)
      }
      if (val) {
        this.pinned.forEach((el) => {
          el.destroy()
        })
      }
    }
  },
  mounted () {
    if (!this.isToggleable) {
      this.isCollapsed = false
    }
    if (this.isCollapsed) {
      slideToggle(this.$refs.body, false, 0)
    }
    if (!this.isCollapsed) {
      this.$nextTick(() => {
        this.pinElements()
      })
    }
  },
  beforeDestroy () {
    this.pinned.forEach((el) => {
      el.destroy()
    })
  }
}
</script>

<style lang="scss" scoped>
.training {
  background: $color-white;
  border: 2px solid map_get($color-neutral-black, 15);
  border-radius: $border-radius;
  padding: 2px;
  position: relative;

  &__header {
    width: 100%;
    position: relative;
    z-index: 3;
    text-decoration: none;
    color: inherit;
    cursor: auto;

    .training_toggleable & {
      cursor: pointer;
      user-select: none;
    }
  }

  &__header-row {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: $color-white;
    padding: 0 6px 12px;
    position: relative;

    &_first {
      padding-top: 12px;
      z-index: 3;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: map_get($color-neutral-black, 4);
      transition: $transition-default background-color;
    }

    .training_collapsed &::before {
      background-color: transparent;
    }
  }

  &__header-col {
    flex: 0 0 auto;
    max-width: 100%;
    padding: 0 10px;
    position: relative;
  }

  &__icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    background-color: $bg-dark;
    color: $color-white;
    margin-right: -4px;
    position: relative;

    @media (max-width: 359px) {
      width: 32px;
      height: 32px;
    }

    .icon {
      width: 50%;
      height: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__info {
    flex: 1 1 100%;
    min-width: 0;
  }

  &__info-title,
  &__info-text {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__coins {
    margin-left: 40 + 16px;
  }

  &__collapse {
    line-height: 0;
    margin-left: auto;
  }

  &__body {
    position: relative;
    overflow: hidden;
  }

  &__body-wrap {
    padding: 16px 16px 20px;
  }
}

.training-interval {
  display: flex;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  &__time {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 40px;
    white-space: nowrap;
    margin-right: 16px;
    @include text-sm;
    color: map_get($color-neutral-black, 45);
    position: relative;

    .t1,
    .t2 {
      width: 100%;
      text-align: center;
      position: relative;
      background-color: $color-white;
      z-index: 2;
    }

    .t1 {
      margin-bottom: auto;
    }

    .t2 {
      top: auto !important;
      bottom: 0 !important;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;
      width: 1px;
      background-color: map_get($color-neutral-black, 15);
    }
  }

  &__source {
    flex-grow: 1;
  }
}

.training-tracker {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 -4px 8px;
    position: relative;
    z-index: 1;
  }

  &__name,
  &__details {
    padding: 0 4px;
    max-width: 100%;
  }
  &__name {
    flex: 1 1 auto;
    min-width: 0;
  }
  &__details {
    flex: 0 0 auto;
  }
}

.metrics {
  display: flex;
  flex-wrap: wrap;
  margin: -8px -4px 0;

  &__item {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
    padding: 8px 4px 0;

    @media (min-width: breakpoint(sm)) {
      max-width: 50%;
    }

    @media (min-width: breakpoint(md)) {
      max-width: 100/3 * 1%;
    }
  }
}
</style>
